import { Outlet, createFileRoute  } from '@tanstack/react-router'
import { ProtectedRoute, RequireModule } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/financeiro',
)({
  component: function FinanceiroLayoutRoute() {
    const { dashboardId } = Route.useParams()
    
    return (
      <RequireModule module={MODULES.FINANCEIRO} dashboardId={dashboardId}>
        <ProtectedRoute capability={CAPABILITIES.FINANCE_FULL}>
          <Outlet />
        </ProtectedRoute>
      </RequireModule>
    )
  },
})
